import axios from "api/axios.js";

const zohoClientURL = "/api/zoho/dealerships/ratings";
const zohoClientCreateURL = "/api/zoho/create-account";
const zohoClientUpdateURL = "/api/zoho/update-account";
const zohoTaskURL = "/zoho-projects/fetch-task-templates";
const zohoProjectURL = "/zoho-projects/create-project";
const zohoAddTaskURL = "/zoho-projects/add-tasks-to-project";

export async function getZohoClients() {
  const controller = new AbortController();
  try {
    const response = await axios.get(zohoClientURL, {
      signal: controller.signal,
    });
    return response.data;
  } catch (err) {
    console.error(err);
  } finally {
    controller.abort();
  }
}

export async function addTaskToProject(data) {
  const controller = new AbortController();
  try {
    const response = await axios.post(zohoAddTaskURL, data, {
      signal: controller.signal,
    });
    console.log(response);
    return response.data;
  } catch (err) {
    console.error(err);
  } finally {
    controller.abort();
  }
}

export async function getTaskList() {
  const controller = new AbortController();
  try {
    const response = await axios.get(zohoTaskURL, {
      signal: controller.signal,
    });
    return response.data;
  } catch (err) {
    console.error(err);
  } finally {
    controller.abort();
  }
}

export async function createCrmAccount(data) {
  console.log("Creating CRM Account with data:", data); // Ensure this logs
  const controller = new AbortController();
  try {
    const response = await axios.post(zohoClientCreateURL, data, {
      signal: controller.signal,
    });
    console.log("createCrmAccount response:", response); // Add log here
    return response.data;
  } catch (err) {
    console.error("Error in createCrmAccount:", err); // Ensure error is logged
  } finally {
    controller.abort();
  }
}

export async function updateCrmAccount(data) {
  console.log("Updating CRM Account with data:", data); // Ensure this logs
  const controller = new AbortController();
  try {
    const response = await axios.put(zohoClientUpdateURL, data, {
      signal: controller.signal,
    });
    console.log("updateCrmAccount response:", response); // Add log here
    return response.data;
  } catch (err) {
    console.error("Error in updateCrmAccount:", err); // Ensure error is logged
  } finally {
    controller.abort();
  }
}

export async function createClientProject(data) {
  const controller = new AbortController();
  try {
    const response = await axios.post(zohoProjectURL, data, {
      signal: controller.signal,
    });
    return response.data;
  } catch (err) {
    console.error(err);
  } finally {
    controller.abort();
  }
}
